import React from 'react';
import {
  Accordion,
  AccordionHeader,
  AccordionItem,
  AccordionIconButton,
  AccordionPanel,
  Typography,
} from '@tq/ui-components';
import { tqc } from '@tq/ui-components/dist/system';

import { DfiReportFormattedMetrics, KpiCategory, TqEnReportFormattedMetrics } from 'types';
import { KpiValueCard, KpiTableCard } from '.';

export type KpiAccordionProps = {
  kpiData: DfiReportFormattedMetrics | TqEnReportFormattedMetrics | undefined;
  titles: Record<string, string>;
};

export const KpiAccordion: React.FC<KpiAccordionProps> = ({ kpiData, titles }) => {
  const getDataTestId = (key: string) => {
    const label = titles[key]
      ? titles[key]
          .toLowerCase()
          .replaceAll(/[\W_]+/g, ' ')
          .trimEnd()
          .replaceAll(' ', '-')
      : '';
    return 'accordion-' + label;
  };

  if (kpiData !== undefined) {
    return (
      <Accordion allowMultiple defaultIndex={[0]} mt={8}>
        {Object.entries(kpiData).map(
          ([key, value]) =>
            !!value.length && (
              <AccordionItem key={key} mt={5} data-testid={getDataTestId(key)}>
                <AccordionHeader>
                  <Typography flex='1' textAlign='left'>
                    <tqc.h3 marginBottom={0}>{titles[key]}</tqc.h3>
                  </Typography>
                  <AccordionIconButton />
                </AccordionHeader>
                <AccordionPanel overflowX='auto'>
                  {(key as KpiCategory) === KpiCategory.lateResponseStatItems ? (
                    <KpiTableCard lateResponses={value} />
                  ) : (
                    <KpiValueCard kpiValues={value} />
                  )}
                </AccordionPanel>
              </AccordionItem>
            )
        )}
      </Accordion>
    );
  } else {
    return null;
  }
};
